module.exports = __webpack_public_path__ + "files/62f2fe8d43dd49589fe6c388e90adba0.png";